/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Usage_LimitInputs */

const fr_api_usage_limit = /** @type {(inputs: Api_Usage_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite d’utilisation atteinte. Contactez un administrateur pour connaître les options disponibles.`)
};

const en_api_usage_limit = /** @type {(inputs: Api_Usage_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage limit reached. Contact an administrator about the available options.`)
};

/**
* | output |
* | --- |
* | "Usage limit reached. Contact an administrator about the available options." |
*
* @param {Api_Usage_LimitInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_usage_limit = /** @type {((inputs?: Api_Usage_LimitInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Usage_LimitInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_usage_limit(inputs)
	return fr_api_usage_limit(inputs)
});